import { Component, OnInit, Input } from '@angular/core';
import { BatchSearch } from '../batch-search'
import { Project } from '../project'
import { BatchSearchService }  from '../batch-search.service'


@Component({
  selector: 'app-batch-search-box',
  templateUrl: './batch-search-box.component.html',
  styleUrls: ['./batch-search-box.component.css']
})
export class BatchSearchBoxComponent implements OnInit {
  @Input() batchSearch: BatchSearch
  @Input() project: Project
  isExpanded = false
  isDeleteMode = false

  constructor(
    private bss:BatchSearchService
  ) { }

  ngOnInit() {
    }

  makeCurrent() {
    this.bss.makeCurrent(this.project, this.batchSearch)
  }

  switchDeleteMode() {
    this.isDeleteMode = !this.isDeleteMode
  }

  confirmDelete() {
    this.bss.delete(this.project, this.batchSearch)
  }

}



// WEBPACK FOOTER //
// ./src/app/batch-search-box/batch-search-box.component.ts